.radio-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--rc-theme-spacing-xs) var(--rc-theme-spacing-ms);

  :global(.ant-radio-button-label) {
    display: flex;
    gap: var(--rc-theme-spacing-xs);
  }

  :global(.ant-wave) {
    display: none;
  }

  &:hover:not(:has(input:disabled)) {
    border-color: var(--rc-theme-color-text-default);
    color: var(--rc-theme-color-text-default);
  }

  &:has(input:disabled) {
    border-color: var(--rc-theme-color-surface-disabled);
    background: none;
    color: var(--rc-theme-color-text-disabled);
  }

  &&:has(input:checked) {
    border-color: transparent;

    &:hover {
      border-color: transparent;
    }

    &:has(input:disabled) {
      background: var(--rc-theme-color-surface-disabled);
    }
  }

  &.radio-button--large {
    height: var(--rc-theme-react-components-button-size-large);
  }

  &.radio-button--middle {
    height: var(--rc-theme-react-components-button-size-middle);
  }

  &.radio-button--small {
    height: var(--rc-theme-react-components-button-size-small);
    padding: var(--rc-theme-spacing-xxs) var(--rc-theme-spacing-xs);
  }
}
